import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrMapComponent } from './pr-map.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [PrMapComponent],
  imports: [CommonModule, GoogleMapsModule],
  exports: [PrMapComponent],
})
export class PrMapModule {}
